import { _getBuyerSupportLink as getBuyerSupportLink } from '../src/getSupportLink';

export default getBuyerSupportLink;
